export default __webpack_public_path__ + "static/media/xk.b15361c3.svg";